/**
 * Hooks up controls for the header component
 */
export const headerComponent = (): void => {
  const headerElement = document.querySelector('.js-header') as unknown as HTMLElement

  window.addEventListener('scroll', () => {
    checkForScroll()
  })

  const checkForScroll = () => {
    const scolledFromTop = window.scrollY

    if (scolledFromTop > 0) {
      headerElement.classList.add('-hasBg')
    } else {
      headerElement.classList.remove('-hasBg')
    }
  }

  checkForScroll()
}
